/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnablingServiceVideoDetailResponse } from '../../models/enabling-service-video-detail-response';

export interface GetEnablingServiceVideoDetail$Params {
  id: number;
}

export function getEnablingServiceVideoDetail(http: HttpClient, rootUrl: string, params: GetEnablingServiceVideoDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<EnablingServiceVideoDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getEnablingServiceVideoDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnablingServiceVideoDetailResponse>;
    })
  );
}

getEnablingServiceVideoDetail.PATH = '/api/ambassador-enabling-services/video/{id}';
